import { GroupsIcon, PeopleIcon, Person2Icon } from "src/Pages/components/Icons/Icons";

export const objColorsChipsFunctionProducer = {
  CORRETOR: {
    color: "#0e6aff",
    label: "Corretor",
    icon: <Person2Icon sx={{ width: "18px", "& > *": { color: "#0e6aff" } }} />,
  },
  SUPERVISOR: {
    color: "#9F0EFF",
    label: "Supervisor",
    icon: <GroupsIcon sx={{ width: "18px", "& > *": { color: "#9F0EFF" } }} />,
  },
  GERENTE: {
    color: "#2C9D48",
    label: "Gerente",
    icon: <PeopleIcon sx={{ width: "18px", "& > *": { color: "#2C9D48" } }} />,
  },
}
